import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanoContasEmpresaListarComponent } from './plano-contas-empresa-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: PlanoContasEmpresaListarComponent }
  ])],
  exports: [RouterModule]
})
export class PlanoContasEmpresaListarRoutingModule { }
